import styled from "styled-components";
import { scarpaGray500, archiaRegular } from "../StylesConstants";
export const Wrapper = styled.div.withConfig({
  displayName: "AlertPaymentstyle__Wrapper",
  componentId: "sc-1w6ifgv-0"
})(["margin-bottom:16px;font-family:", ";font-size:14px;font-weight:400;line-height:20px;text-align:left;color:", ";"], archiaRegular, scarpaGray500);